import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=0c070d8a&scoped=true"
import script from "./payResult.vue?vue&type=script&lang=js"
export * from "./payResult.vue?vue&type=script&lang=js"
import style0 from "./payResult.vue?vue&type=style&index=0&id=0c070d8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c070d8a",
  null
  
)

export default component.exports